import axios from "../../../axiosClient";

export const getDimmingProfile = async (
  pageSize: any,
  PageNumber: any,
  SortBy: any,
  SortDirection: any,
  id: any
) => {
  const body = {
    pageSize,
    PageNumber,
    SortBy,
    SortDirection,
  };
  const res = await axios.get(`/slpapp/DimmingProfile/GetDimmingProfile`, {
    params: { assetCode: id, ...body },
  });

  return res?.data;
};
